import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Authorization, UserDto } from '../models/data.model';

@Injectable({
  providedIn: 'root'
})
export class LocalSettingsService {

  constructor(private translate: TranslateService) { }

  getLanguage(): string {
    console.log('here LocalSettingsService');
    if (localStorage) {
      return localStorage['language'] || 'en';
    }
    else {
      return 'en';
    }
  }

  setLanguage(language: string) {
    if (localStorage) {
      localStorage['language'] = language;
    }
  }

  getCredential(): UserDto {
    console.log('here LocalSettingsService');
    let user = new UserDto();
    if (localStorage) {
      user.username = localStorage['user'] ? localStorage['user'] : '';
      user.password = localStorage['pass'] ? localStorage['pass'] : '';
    }
    return user;

  }

  setCredential(auth: UserDto) {
    if (localStorage) {
      let user = new UserDto();
      localStorage['user'] = auth.username;
      localStorage['pass'] = auth.password;      
    }
  }

}
